import { FC } from 'react';

import { changeMode, getSurveyAsync } from '../surveySlice';

import { GenericList } from '../../../shared/components/GenericList/GenericList';
import { ModeEnum, StatusEnum } from '../../../shared/models/Enums';
import { EditSurveyData } from '../models/EditSurveyData';
import { ResourcesService } from '../../../shared/services/ResourcesService';
import { selectUserLanguage } from '../../login/loginSlice';
import { useAppSelector } from '../../../app/hooks';

type SurveysListProps = {
    surveys: EditSurveyData[],
    surveyStatus: StatusEnum,
    dispatch: Function
    loadSurveyEdit: Function,
    query: string
    setQuery: Function,
    onNext: Function,
    onPrevious: Function,
};

export const SurveysList: FC<SurveysListProps> = ({
    surveys, surveyStatus, dispatch, loadSurveyEdit, query, setQuery, onNext, onPrevious
}) => {
    const lang = useAppSelector(selectUserLanguage);
    const tableHeaders = ['#', ResourcesService.translate('Title', lang), ResourcesService.translate('Section', lang)];

    return (
        <GenericList
            lang={lang}
            h2={ResourcesService.translate('Surveys', lang)}
            headContent={
                <tr>
                    {
                        tableHeaders.map(h => <th key={h}>{h}</th>)
                    }
                </tr>
            }
            bodyContent={
                surveys.map((s, i) =>
                    <tr key={i} onClick={() => dispatch(getSurveyAsync(s.id))}>
                        <td>{s.id.substring(0, 8)}...</td>
                        <td>{ResourcesService.translateInput(s.titleBg, s.titleEn, s.titleThird, lang,)}</td>
                        <td>{s.sectionsCount}</td>
                    </tr>
                )
            }
            listStatus={surveyStatus}
            numberOfRows={5}
            numberOfColumns={tableHeaders.length}
            onCreateClick={() => dispatch(changeMode(ModeEnum.Create))}
            searchValue={query}
            onSearch={(value: string) => dispatch(setQuery(value))}
            onNext={() => dispatch(onNext())}
            onPrevious={() => dispatch(onPrevious())}
        />
    );
}